import { memo } from "react"

const IconApiEndpoints = () => {
  return (
    <svg
      stroke="#6062CB"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      color="#6062CB"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc></desc>
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M4 13h5"></path>
      <path d="M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"></path>
      <path d="M20 8v8"></path>
      <path d="M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"></path>
    </svg>
  )
}

export default memo(IconApiEndpoints)
